import { bool } from "prop-types";
import { observer } from "mobx-react";
import { Collapse } from "@material-ui/core";
import { useEstimateEditorSettings, useEstimateEditorStore, useEstimateStructure } from "@tools";
import { TimelineBillingContents } from "./parts/TimelineBillingContents";
import { TimelineSectionContents } from "./parts/TimelineSectionContents";
import { TimelineUtilizationContents } from "./parts/TimelineUtilizationContents";
import { TimelineTotalDistributionRow } from "./parts/TimelineTotalDistributionRow";
import useStyle from "./TimelineOverlay.style";

export const TimelineOverlay = observer(({ fullSectionActions }) => {
  const structure = useEstimateStructure();
  const { isSellerOrClient } = useEstimateEditorSettings();
  const { visibilityMode } = useEstimateEditorStore();
  const classes = useStyle({ fullSectionActions });

  const { settings, visibility } = structure;
  const { apply } = visibility;

  const visible = (enabled, hidden) => enabled && (!apply || visibilityMode || !hidden);
  const showSections = visible(settings.useTimelineSections, visibility.hideTimelineSections);
  const showUtilization = visible(settings.useTimelineUtilization, visibility.hideTimelineUtilization);
  const showBilling = isSellerOrClient && visible(settings.useTimelineBilling, visibility.hideTimelineBilling);

  return (
    <div className={classes.root}>
      {
        showSections &&
        <>
          <div className={classes.titleSpacer} />
          <Collapse
            in={settings.expandTimelineSections}
            mountOnEnter unmountOnExit
          >
            <TimelineSectionContents />
          </Collapse>
        </>
      }
      {
        showUtilization &&
        <>
          <TimelineTotalDistributionRow />
          <Collapse
            in={settings.expandTimelineUtilization}
            mountOnEnter unmountOnExit
          >
            <TimelineUtilizationContents />
          </Collapse>
        </>
      }
      {
        showBilling &&
        <>
          <div className={classes.titleSpacer} />
          <Collapse
            in={settings.expandTimelineBilling}
            mountOnEnter unmountOnExit
          >
            <TimelineBillingContents />
          </Collapse>
        </>
      }
    </div>
  );
});

TimelineOverlay.propTypes = {
  fullSectionActions: bool,
};
